
import React from "react";
import SVG from "react-inlinesvg";
import { Modal } from "react-bootstrap";
import {formatDate} from "../../../../../../../../util/Helpers"
import { toAbsoluteUrl } from "../../../../../../../../../_metronic/_helpers";

const ViewBankAccountModal = ({showViewBankAccountModal, details, onHide}) => {

  return (
    <Modal
        show={showViewBankAccountModal}
        onHide={onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
      >
      
        <Modal.Header >
          <Modal.Title id="contained-modal-title-vcenter">
            <span className={`svg-icon svg-icon-lg svg-icon-primary mr-3`}>
                <SVG
                    title=""
                    src={toAbsoluteUrl("/media/svg/icons/Shopping/Money.svg")}
                />
            </span>
            Bank Account Details
          </Modal.Title>
          <button type="button" className="close" onClick={onHide}>
              <span aria-hidden="true" className="d-block">×</span>
              <span className="sr-only">Close</span>
           </button>
        </Modal.Header>
        <Modal.Body 
            className="px-10 py-2"
        >   
            <div className="row">
                <div className="col-lg-7 py-4">
                    <h6 className=" px">Reference</h6>
                    <span className="text-muted">{details?.ref}</span>
                </div>
                <div className="col-lg py-5">
                    <h6 className=" px">Account Name</h6>
                    <span className="text-muted">{details?.accountName}</span>
                </div>
            </div>
            <div className="row">
                <div className="col-lg py-4">
                    <h6 className=" px">Currency</h6>
                    <span className="text-muted">{details?.currency}</span>
                </div>
                <div className="col-lg py-4">
                    <h6 className=" px">Account Type</h6>
                    <span className="text-muted">{details?.accountType}</span>
                </div>
                <div className="col-lg py-4">
                    <h6 className=" px">Account Number</h6>
                    <span className="text-muted">{details?.accountNumber}</span>
                </div>
                <div className="col-lg py-4">
                    <h6 className=" px">Bank Name</h6>
                    <span className="text-muted">{details?.bankName}</span>
                </div>
            </div>
            <div className="row">
                <div className="col-lg py-4">
                    <h6 className=" px">Status</h6>
                    <span className="text-muted">{details?.status}</span>
                </div>
                <div className="col-lg py-4">
                    <h6 className=" px">Swift / ABA Code</h6>
                    <span className="text-muted">{details?.swiftAba}</span>
                </div>
                <div className="col-lg py-4">
                    <h6 className=" px">Bank Address</h6>
                    <span className="text-muted">{details?.bankAddress ?? "Nil"}</span>
                </div>
                <div className="col-lg py-4">
                    <h6 className=" px">Bank City</h6>
                    <span className="text-muted">{details?.bankCity ?? "Nil"}</span>
                </div>
            </div>
            <div className="row">
                <div className="col-lg py-4">
                    <h6 className=" px">Bank Province</h6>
                    <span className="text-muted">{details?.bankProvince ?? "Nil"}</span>
                </div>
                <div className="col-lg py-4">
                    <h6 className=" px">Bank Zip Code</h6>
                    <span className="text-muted">{details?.bankZipCode ?? "Nil"}</span>
                </div>
                <div className="col-lg py-4">
                    <h6 className=" px">Country Code</h6>
                    <span className="text-muted">{details?.bankCountryCode}</span>
                </div>
                <div className="col-lg py-4">
                    <h6 className=" px">Created At</h6>
                    <span className="text-muted">{formatDate(details?.createdAt)}</span>
                </div>
            </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
            <button
                type="button"
                onClick={onHide}
                className="btn btn-primary btn-elevate px-5"
            >
                Okay
            </button>
        </Modal.Footer>
      </Modal>

        );
}

export default ViewBankAccountModal;